// extracted by mini-css-extract-plugin
export var accountContent = "product-favorites-module--account-content--O7ROV";
export var error = "product-favorites-module--error--jlIeP";
export var favoriteButton = "product-favorites-module--favorite-button--CfLdz";
export var info = "product-favorites-module--info--fZZy8";
export var productActions = "product-favorites-module--product-actions--ECm+x";
export var productBody = "product-favorites-module--product-body--SWgIy";
export var productButton = "product-favorites-module--product-button--vuN23";
export var productCard = "product-favorites-module--product-card--hSSle";
export var productImage = "product-favorites-module--product-image--ZHqx+";
export var productImageBox = "product-favorites-module--product-image-box--8WnEx";
export var productMeta = "product-favorites-module--product-meta--dyVFl";
export var productTitle = "product-favorites-module--product-title--CC8Lq";
export var productsGrid = "product-favorites-module--products-grid--yGpCK";
export var sectionHeader = "product-favorites-module--section-header--4FBZv";
export var sectionHeaderDescription = "product-favorites-module--section-header-description--z2JnH";
export var sectionHeaderTitle = "product-favorites-module--section-header-title--OjROi";